export default __webpack_public_path__ + "static/media/figure-area.0c4ced90.svg";